import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface Segment {
  id: string;
  name: string;
}

const fetchSegments = async (): Promise<Segment[]> => {
  try {
    const { data } = await api.get<Segment[]>('/api/segments');
    return data;
  } catch (error) {
    throw new Error('Error al cargar los segmentos');
  }
};

export const useSegments = () => {
  const { data: segments = [] } = useQuery({
    queryKey: ['segments'],
    queryFn: fetchSegments,
  });

  return {
    segments,
  };
}; 